__turbopack_context__.v({
  "breadcrumbs": "style-module-scss-module__FjAyKG__breadcrumbs",
  "breadcrumbsWrap": "style-module-scss-module__FjAyKG__breadcrumbsWrap",
  "content": "style-module-scss-module__FjAyKG__content",
  "tag": "style-module-scss-module__FjAyKG__tag",
  "tagsContainer": "style-module-scss-module__FjAyKG__tagsContainer",
  "title": "style-module-scss-module__FjAyKG__title",
  "video": "style-module-scss-module__FjAyKG__video",
  "wrapper": "style-module-scss-module__FjAyKG__wrapper",
});
